export const snackConstants = {
  SNACK_SHOW: 'SNACK_SHOW',
  SNACK_CLEAR: 'SNACK_CLEAR',
};
